export default __webpack_public_path__ + "static/media/record-phrase-p1.ccc7eccd.jpg";